export const ACCESSIBILITY_TEXTS = {
    GO_BACK: "Go Back",
};

export const HEADER_TITLE = {
    ADD_NEW_CARD: "Add New Card",
    MANAGE_CARD: "Manage Card",
    SECURE_CARD: "Secure Card",
};
